module.exports = __webpack_public_path__ + "static/media/8.deb8d932.jpg";